import {
  CLIFF_DURATION_DAYS,
  VESTING_DURATION_DAYS,
  VESTING_START_DATE,
} from "@/config";

export const getVestingTimeRemaining = () => {
  const vestingEndDate = new Date(VESTING_START_DATE);
  vestingEndDate.setDate(vestingEndDate.getDate() + VESTING_DURATION_DAYS);

  const difference = vestingEndDate.getTime() - new Date().getTime();

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0 };
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

  return { days, hours, minutes };
};

export const getCliffTimeRemaining = () => {
  const cliffEndTime = new Date(VESTING_START_DATE);

  const difference = cliffEndTime.getTime() - new Date().getTime();

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0, percentage: 0 };
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

  return {
    days: days,
    hours,
    minutes,
    percentage:
      ((CLIFF_DURATION_DAYS * 24 * 60 * 60 * 1000 - difference) * 100) /
      (CLIFF_DURATION_DAYS * 24 * 60 * 60 * 1000),
  };
};
